import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  EventKindDto,
  EventListItemDto,
  useCopySourcingEventV2Mutation,
  useCreateSourcingEventCopyMutation,
} from "../../autogen/bff-api";
import { useApiError } from "../../common/errors/useApiError";
import { urls } from "../../urls";

export const useCombinedEventRowActions = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { triggerSoft } = useApiError();
  const [copyV1Event, { isLoading: isCopyingV1 }] = useCreateSourcingEventCopyMutation();
  const [copyV2Event, { isLoading: isCopyingV2 }] = useCopySourcingEventV2Mutation();

  const copyEvent = async (event: EventListItemDto) => {
    try {
      if (event.kind === EventKindDto.V2) {
        const copy = await copyV2Event({ eventId: event.id }).unwrap();
        navigate(urls.publicEvents.edit.go(copy.id).info);
        return;
      }
      const copy = await copyV1Event({ eventId: event.id }).unwrap();
      navigate(urls.events.edit.go(copy.id).intro);
    } catch (e) {
      triggerSoft(e);
    }
  };

  return {
    copyEvent,
    isCopying: isCopyingV1 || isCopyingV2,
    copyDisabledReason: (event: EventListItemDto) =>
      event.canEdit ? undefined : t("Only admins and creators can copy events"),
  };
};
